import axios from "axios";
import { getToken, clearToken } from "@/lib/token";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Respaldo contra registros duplicados: si la MISMA operación (método + ruta + datos) se envía otra vez mientras
// la primera sigue en curso (doble clic en Guardar, Enter repetido), se reutiliza la primera solicitud.
const enCurso = new Map();
const adaptadorBase = axios.getAdapter(api.defaults.adapter || axios.defaults.adapter);
api.defaults.adapter = (config) => {
  const metodo = (config.method || "get").toLowerCase();
  const esArchivo = typeof FormData !== "undefined" && config.data instanceof FormData;
  if (!["post", "put", "patch", "delete"].includes(metodo) || esArchivo) return adaptadorBase(config);
  const clave = `${metodo} ${config.baseURL || ""}${config.url} ${JSON.stringify(config.params || {})} ${
    typeof config.data === "string" ? config.data : JSON.stringify(config.data ?? "")}`;
  if (enCurso.has(clave)) return enCurso.get(clave);
  const p = adaptadorBase(config).finally(() => enCurso.delete(clave));
  enCurso.set(clave, p);
  return p;
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const companyId = localStorage.getItem("agroport_company_id");
  if (companyId) {
    config.headers["X-Company-Id"] = companyId;
  }
  const branchId = localStorage.getItem("agroport_branch_id");
  if (branchId) {
    config.headers["X-Branch-Id"] = branchId;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.includes("/login")) {
      // Sesión vencida (inactividad / duración máxima) o cerrada: se explica en el inicio de sesión
      const msg = err?.response?.data?.detail;
      if (getToken() && typeof msg === "string" && /sesi[oó]n/i.test(msg)) {
        try { sessionStorage.setItem("agroport_aviso_sesion", msg); } catch { /* sin almacenamiento */ }
      }
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
